export default __webpack_public_path__ + "static/media/zlogo.61afbff9.svg";